import React from "react";
import PropTypes from "prop-types";

import BluGraphContainer from "./common/BluGraphContainer";

import VictimsGraph from "./VictimsGraph";

import "./common/BluGraphContainer.scss";

/*
Constants
*/

const REDUX_NAME = "victims";
export const GRAPH_TITLE = "Top 10 Attack Targets";

/*
Main component
*/

const Victims = ({ showTitle = false, showSubtitle = true }) => (
  <BluGraphContainer
    defaultTitle={GRAPH_TITLE}
    Graph={VictimsGraph}
    labelField="dstIp"
    reduxName={REDUX_NAME}
    showSubtitle={showSubtitle}
    showTitle={showTitle}
  />
);

Victims.propTypes = {
  showSubtitle: PropTypes.bool,
  showTitle: PropTypes.bool,
};

Victims.defaultProps = {
  showSubtitle: true,
  showTitle: false,
};

export default Victims;
